module.exports = "<div class=\"confirm-password-set-dialog-root\">\n  <h3 class=\"confirm-header\">New password was set successfully</h3>\n  <md-dialog-actions>\n    <button md-raised-button (click)=\"dialog.close()\">\n      <span>OK</span>\n    </button>\n  </md-dialog-actions>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forgot-password/confirm-password-set-dialog/confirm-password-set-dialog.component.html
// module id = 179
// module chunks = 1